'use client';

import { Banner } from '@flipster/apis/v1/banner/types';
import { useCheckSpotOnly } from '@flipster/features/src/shared/regulation';
import { useMounted } from '@flipster/react/misc/lifecycle/mount';

import Main from './BaseMain';
import SpotMain from './SpotMain';

interface Props {
  heroCarousel?: Banner[];
  promotions?: Banner[];
}

const MainPage = (props: Props) => {
  const isSpotOnly = useCheckSpotOnly();
  const isMounted = useMounted();

  if (isSpotOnly && isMounted) {
    return <SpotMain />;
  }

  return <Main {...props} />;
};

export default MainPage;
